import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, Platform, PopoverController, ActionSheetController, LoadingController, Loading, ModalController } from 'ionic-angular';
import { WheelSelector } from '@ionic-native/wheel-selector';

import { TranslateService } from 'ng2-translate';

import { EmployeeDetailsPage } from '../employees/employee-details/employee-details';
import { IEmployee, ITimeRegistration, TimeRegistration, IProject, Project } from '../../model/top.model';

import { EmployeeData } from '../../providers/employee-data';
import { TimeRegistrationData } from '../../providers/time-registration-data';

import { EditMode, TimeRegistrationStatus, TimeRegistrationType } from '../../enums/enums';

import { TimeRegistrationStatusPipe, TimeRegistrationTypePipe } from '../../pipes/time-registration-pipe/time-registration-pipe';

import { ProjectData } from '../../providers/project-data';
import { MenuComponent } from '../../components/menu/menu';
import { BaseRequestOptions } from '@angular/http';
import { SelectDownloadModal } from '../../modals/select-download/select-download';

@Component({
  selector: 'page-time-registrations-period',
  templateUrl: 'time-registrations-period.html'
})
export class TimeRegistrationsPeriodPage {
  private isMobile: boolean;
  private employees: Array<IEmployee>;
  private filteredEmployees: Array<IEmployee>;
  private weekNumber: string;
  private maxWeeks: number;
  private week: number;
  private year: string;
  private weeks: Array<number>;
  private weekInMilliseconds: number = 604800000;
  private filterName: string;
  private loadingView: Loading;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private popoverCtrl: PopoverController,
    private alertCtrl: AlertController,
    private actionSheetCtrl: ActionSheetController,
    private employeeData: EmployeeData,
    // private projectData: ProjectData,
    private timeRegistrationData: TimeRegistrationData,
    // private translate: TranslateService,
    private platform: Platform,
    private selector: WheelSelector,
    private loading: LoadingController,
    private modalCtrl: ModalController,
  ) {
    this.filterName = "";
    this.isMobile = platform.is('cordova');
    this.employees = [];
    let weekArrayObject = this.timeRegistrationData.getWeekNumber(new Date());
    this.year = weekArrayObject[0].toString();
    this.week = weekArrayObject[1];
    let modulo = this.week % 4;
    if (modulo == 0) {
      this.week = this.week - 3;
    } else {
      this.week = this.week - this.week % 4 + 1;
    }
  }
  ionViewDidEnter() {
    this.initWeek();
  }

  getHeaderStyle(employee: IEmployee) {
    return 'time-registrations-header-' + employee.timeRegistrationsStatus;
  }

  getPlatformStyle() {
    if (this.platform.is('ios')) {
      return 'platform-ios';
    }
    return 'platform-android';
  }

  filterTimeRegistrations() {
    if (this.employees) {
      this.filteredEmployees = this.employees.filter((employee) => {
        return !(employee.first_name.toLowerCase().indexOf(this.filterName.toLowerCase()) == -1 && employee.last_name.toLowerCase().indexOf(this.filterName.toLowerCase()) == -1)
      });
    }
  }

  initWeek() {
    this.loadingView = this.loading.create({
      content: 'Uren laden...'
    });
    this.loadingView.present().then(() => {
      this.weekNumber = this.week < 10 ? this.year + "-01-01T00:0" + this.week : this.year + "-01-01T00:" + this.week;
      this.weeks = [];
      this.maxWeeks = this.timeRegistrationData.getWeeksInYear(this.year);
      this.weeks.push(1);
      for (var index = 1; index <= this.maxWeeks; index++) {
        if (index % 4 == 0) {
          if (index == 52) {
            if (this.maxWeeks == 53) {
              this.weeks.push(index + 1);
            }
          } else {
            this.weeks.push(index + 1);
          }
        }
      }
      this.setEmployeesTimeRegistrations();
    });
  }

  setEmployeesTimeRegistrations() {
    this.employeeData.getEmployees(true, this.year, this.week.toString()).then((result: Array<IEmployee>) => {
      this.employees = result;

      // this.employees.sort(function (a, b) {
      //   if (a.last_name < b.last_name) return -1;
      //   if (a.last_name > b.last_name) return 1;
      //   if (a.first_name < b.first_name) return -1;
      //   if (a.first_name > b.first_name) return 1;
      //   return 0;
      // });

      this.employees.forEach((employee) => {
        let totalWeek1 = 0;
        let totalWeek2 = 0;
        let totalWeek3 = 0;
        let totalWeek4 = 0;
        let totalSick = 0;
        let totalLeave = 0;
        employee.totalScholingWeek1 = 0;
        employee.totalScholingWeek2 = 0;
        employee.totalScholingWeek3 = 0;
        employee.totalScholingWeek4 = 0;
        employee.totalTvtWeek1 = 0;
        employee.totalTvtWeek2 = 0;
        employee.totalTvtWeek3 = 0;
        employee.totalTvtWeek4 = 0;
        employee.totalLeaveWeek1 = 0;
        employee.totalLeaveWeek2 = 0;
        employee.totalLeaveWeek3 = 0;
        employee.totalLeaveWeek4 = 0;
        employee.totalSickWeek1 = 0;
        employee.totalSickWeek2 = 0;
        employee.totalSickWeek3 = 0;
        employee.totalSickWeek4 = 0;
        employee.remarks = [];
        employee.timeRegistrations.forEach((timeRegistration) => {
          if (timeRegistration.remarks_private) {
            employee.remarks.push(timeRegistration);
          }
          if (timeRegistration.type == TimeRegistrationType.Scholing) {
            employee.totalScholingWeek1 += this.timeRegistrationData.getHoursForTimeRegistration(timeRegistration);
          } else if (timeRegistration.type == TimeRegistrationType.OpbouwTijdVoorTijd) {
            employee.totalTvtWeek1 += this.timeRegistrationData.getHoursForTimeRegistration(timeRegistration);
          } else if (timeRegistration.type == TimeRegistrationType.DokterTandarts ||
            timeRegistration.type == TimeRegistrationType.Ziek) {
            employee.totalSickWeek1 += this.timeRegistrationData.getHoursForTimeRegistration(timeRegistration);
          } else if (timeRegistration.type == TimeRegistrationType.VerlofADV ||
            timeRegistration.type == TimeRegistrationType.VerlofSpeciaal ||
            timeRegistration.type == TimeRegistrationType.VerlofVrijeDag ||
            timeRegistration.type == TimeRegistrationType.FeestDag) {
            employee.totalLeaveWeek1 += this.timeRegistrationData.getHoursForTimeRegistration(timeRegistration);
          } else {
            totalWeek1 += this.timeRegistrationData.getHoursForTimeRegistration(timeRegistration);
          }
        });
        if (employee.totalSickWeek1 > 0) {
          totalSick += employee.totalSickWeek1;
        }
        if (employee.totalLeaveWeek1 > 0) {
          totalLeave += employee.totalLeaveWeek1;
        }
        employee.timeRegistrations2.forEach((timeRegistration) => {
          if (timeRegistration.remarks_private) {
            employee.remarks.push(timeRegistration);
          }
          if (timeRegistration.type == TimeRegistrationType.Scholing) {
            employee.totalScholingWeek2 += this.timeRegistrationData.getHoursForTimeRegistration(timeRegistration);
          } else if (timeRegistration.type == TimeRegistrationType.OpbouwTijdVoorTijd) {
            employee.totalTvtWeek2 += this.timeRegistrationData.getHoursForTimeRegistration(timeRegistration);
          } else if (timeRegistration.type == TimeRegistrationType.DokterTandarts ||
            timeRegistration.type == TimeRegistrationType.Ziek) {
            employee.totalSickWeek2 += this.timeRegistrationData.getHoursForTimeRegistration(timeRegistration);
          } else if (timeRegistration.type == TimeRegistrationType.VerlofADV ||
            timeRegistration.type == TimeRegistrationType.VerlofSpeciaal ||
            timeRegistration.type == TimeRegistrationType.VerlofVrijeDag ||
            timeRegistration.type == TimeRegistrationType.FeestDag) {
            employee.totalLeaveWeek2 += this.timeRegistrationData.getHoursForTimeRegistration(timeRegistration);
          } else {
            totalWeek2 += this.timeRegistrationData.getHoursForTimeRegistration(timeRegistration);
          }
        });
        if (employee.totalSickWeek2 > 0) {
          totalSick += employee.totalSickWeek2;
        }
        if (employee.totalLeaveWeek2 > 0) {
          totalLeave += employee.totalLeaveWeek2;
        }
        employee.timeRegistrations3.forEach((timeRegistration) => {
          if (timeRegistration.remarks_private) {
            employee.remarks.push(timeRegistration);
          }
          if (timeRegistration.type == TimeRegistrationType.Scholing) {
            employee.totalScholingWeek3 += this.timeRegistrationData.getHoursForTimeRegistration(timeRegistration);
          } else if (timeRegistration.type == TimeRegistrationType.OpbouwTijdVoorTijd) {
            employee.totalTvtWeek3 += this.timeRegistrationData.getHoursForTimeRegistration(timeRegistration);
          } else if (timeRegistration.type == TimeRegistrationType.DokterTandarts ||
            timeRegistration.type == TimeRegistrationType.Ziek) {
            employee.totalSickWeek3 += this.timeRegistrationData.getHoursForTimeRegistration(timeRegistration);
          } else if (timeRegistration.type == TimeRegistrationType.VerlofADV ||
            timeRegistration.type == TimeRegistrationType.VerlofSpeciaal ||
            timeRegistration.type == TimeRegistrationType.VerlofVrijeDag ||
            timeRegistration.type == TimeRegistrationType.FeestDag) {
            employee.totalLeaveWeek3 += this.timeRegistrationData.getHoursForTimeRegistration(timeRegistration);
          } else {
            totalWeek3 += this.timeRegistrationData.getHoursForTimeRegistration(timeRegistration);
          }
        });
        if (employee.totalSickWeek3 > 0) {
          totalSick += employee.totalSickWeek3;
        }
        if (employee.totalLeaveWeek3 > 0) {
          totalLeave += employee.totalLeaveWeek3;
        }
        employee.timeRegistrations4.forEach((timeRegistration) => {
          if (timeRegistration.remarks_private) {
            employee.remarks.push(timeRegistration);
          }
          if (timeRegistration.type == TimeRegistrationType.Scholing) {
            employee.totalScholingWeek4 += this.timeRegistrationData.getHoursForTimeRegistration(timeRegistration);
          } else if (timeRegistration.type == TimeRegistrationType.OpbouwTijdVoorTijd) {
            employee.totalTvtWeek4 += this.timeRegistrationData.getHoursForTimeRegistration(timeRegistration);
          } else if (timeRegistration.type == TimeRegistrationType.DokterTandarts ||
            timeRegistration.type == TimeRegistrationType.Ziek) {
            employee.totalSickWeek4 += this.timeRegistrationData.getHoursForTimeRegistration(timeRegistration);
          } else if (timeRegistration.type == TimeRegistrationType.VerlofADV ||
            timeRegistration.type == TimeRegistrationType.VerlofSpeciaal ||
            timeRegistration.type == TimeRegistrationType.VerlofVrijeDag ||
            timeRegistration.type == TimeRegistrationType.FeestDag) {
            employee.totalLeaveWeek4 += this.timeRegistrationData.getHoursForTimeRegistration(timeRegistration);
          } else {
            totalWeek4 += this.timeRegistrationData.getHoursForTimeRegistration(timeRegistration);
          }
        });
        if (employee.totalSickWeek4 > 0) {
          totalSick += employee.totalSickWeek4;
        }
        if (employee.totalLeaveWeek4 > 0) {
          totalLeave += employee.totalLeaveWeek4;
        }

        employee.totalSick = totalSick;
        employee.totalLeave = totalLeave;

        let fte = employee.period_minimum ? employee.period_minimum / 4 : employee.fte
        if (employee.fte == 0) {
          fte = 40;
        }

        const total1 = totalWeek1 + employee.totalLeaveWeek1 + employee.totalSickWeek1;
        const total2 = totalWeek2 + employee.totalLeaveWeek2 + employee.totalSickWeek2;
        const total3 = totalWeek3 + employee.totalLeaveWeek3 + employee.totalSickWeek3;
        const total4 = totalWeek4 + employee.totalLeaveWeek4 + employee.totalSickWeek4;

        employee.totalExtraWeek1 = total1 > fte ? total1 - fte : 0;
        employee.totalExtraWeek2 = total2 > fte ? total2 - fte : 0;
        employee.totalExtraWeek3 = total3 > fte ? total3 - fte : 0;
        employee.totalExtraWeek4 = total4 > fte ? total4 - fte : 0;
        employee.totalExtraHours = employee.totalExtraWeek1 + employee.totalExtraWeek2 + employee.totalExtraWeek3 + employee.totalExtraWeek4;

        employee.totalWeek1 = total1 > fte ? totalWeek1 - employee.totalExtraWeek1 : totalWeek1;
        employee.totalWeek2 = total2 > fte ? totalWeek2 - employee.totalExtraWeek2 : totalWeek2;
        employee.totalWeek3 = total3 > fte ? totalWeek3 - employee.totalExtraWeek3 : totalWeek3;
        employee.totalWeek4 = total4 > fte ? totalWeek4 - employee.totalExtraWeek4 : totalWeek4;
        employee.totalHours = employee.totalWeek1 + employee.totalWeek2 + employee.totalWeek3 + employee.totalWeek4;

        totalWeek1 -= employee.totalTvtWeek1;
        totalWeek2 -= employee.totalTvtWeek2;
        totalWeek3 -= employee.totalTvtWeek3;
        totalWeek4 -= employee.totalTvtWeek4;
        employee.totalTvt = employee.totalTvtWeek1 + employee.totalTvtWeek2 + employee.totalTvtWeek3 + employee.totalTvtWeek4;

        employee.totalScholing = employee.totalScholingWeek1 + employee.totalScholingWeek2 + employee.totalScholingWeek3 + employee.totalScholingWeek4;
      });
      this.filterTimeRegistrations();
      this.loadingView.dismiss();
    });
  }

  showRemarks(employee: IEmployee) {
    let message = "";
    let timeRegistrationTypePipe = new TimeRegistrationTypePipe();
    employee.remarks.forEach(timeRegistration => {
      if (message) {
        message += "</br></br>"
      }
      message += "<b>" + timeRegistrationTypePipe.transform(timeRegistration.type) + ", " + this.timeRegistrationData.getHoursForTimeRegistration(timeRegistration) + " uur in week " + timeRegistration.week + ":</b> " + timeRegistration.remarks_private;
    });
    let actionSheet = this.alertCtrl.create({
      title: 'Opmerking(en)',
      message: message,
      buttons: ['Ok']
    });

    actionSheet.present();
  }

  wheelSelectYear() {
    let data = {
      years: []
    }
    for (let index = 2018; index <= 2100; index++) {
      data.years.push({ description: index.toString() });
    }
    this.selector.show({
      title: "Selecteer jaar",
      items: [
        data.years
      ],
      theme: "dark",
      defaultItems: [{ index: 0, value: this.year.toString() }],
      positiveButtonText: "Ok",
      negativeButtonText: "Annuleren"
    }).then(
      result => {
        this.year = result[0].description;
        this.initWeek();
      },
      err => console.log('wheelSelectYear Error: ' + err)
    );
  }

  wheelSelectWeek() {
    let data = {
      weeks: []
    }
    data.weeks.push({ description: "1" });
    for (var index = 1; index <= this.maxWeeks; index++) {
      if (index % 4 == 0) {
        if (index == 52) {
          if (this.maxWeeks == 53) {
            data.weeks.push({ description: (index + 1).toString() });
          }
        } else {
          data.weeks.push({ description: (index + 1).toString() });
        }
      }
    }
    this.selector.show({
      title: "Selecteer week",
      items: [
        data.weeks
      ],
      theme: "dark",
      defaultItems: [{ index: 0, value: this.week.toString() }],
      positiveButtonText: "Ok",
      negativeButtonText: "Annuleren"
    }).then(
      result => {
        this.week = parseInt(result[0].description);
        this.weekNumber = this.week < 10 ? this.year + "-01-01T00:0" + this.week : this.year + "-01-01T00:" + this.week;
        this.initWeek();
      },
      err => console.log('wheelSelectWeek Error: ' + err)
    );
  }

  nextPeriod() {
    if (this.week >= 49) {
      if (this.maxWeeks == 53 && this.week == 49) {
        this.week += 4;
      } else {
        this.week = 1;
        this.year = (parseInt(this.year) + 1).toString();
      }
    } else {
      this.week += 4;
    }
    this.initWeek();
  }

  previousPeriod() {
    if (this.week == 1) {
      this.year = (parseInt(this.year) - 1).toString();
      if (this.timeRegistrationData.getWeeksInYear(this.year) == 53) {
        this.week = 53;
      } else {
        this.week = 49;
      }
    } else {
      this.week -= 4;
    }
    this.initWeek();
  }

  updateFromDateTime() {
    this.week = parseInt(this.weekNumber.substr(14, 2));
    this.initWeek();
  }

  openMenu(event) {
    let popover = this.popoverCtrl.create(MenuComponent, {
      items: [
        {
          icon: 'download',
          text: 'uren',
          action: 'uren'
        }, {
          icon: 'download',
          text: 'verlof',
          action: 'verlof'
        }, {
          icon: 'checkmark-circle-outline',
          text: 'verwerken',
          action: 'verwerken'
        }
      ]
    });
    popover.present({
      ev: event
    });
    popover.onDidDismiss(item => {
      if (item) {
        if (item.action == 'verwerken') {
          this.processPeriod();
          return;
        }
        this.download(item.action);
      }
    });
  }

  processPeriod() {
    let processAlert = this.alertCtrl.create({
      title: 'Verwerken',
      subTitle: 'Weet je zeker dat je deze periode wilt verwerken?',
      buttons: [{
        text: 'Ja',
        handler: () => {
          this.timeRegistrationData.process(this.week, this.year).then(result => {
            alert(result);
          });
        }
      },
      {
        text: 'Nee'
      }]
    });
    processAlert.present();
    return false;
  }

  download(type) {
    const selectDownloadModal = this.modalCtrl.create(SelectDownloadModal, { week: this.week , type});
    selectDownloadModal.present();
    selectDownloadModal.onDidDismiss(res => {
      if (res) {
        this.timeRegistrationData.download(res.week, this.year, type, res.oneWeek);
      }
    });
  }

  openEmployeeWeek(employee, week) {
    this.navCtrl.push(EmployeeDetailsPage, {
      employee: employee,
      week: week,
      year: this.year
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/time-registrations-period/time-registrations-period.ts